// src/utils/utils.js
export const LongDate = (str) => {
    const date = new Date(str);

    // Set the formatting options
    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    
    // Format the date into the desired format
    const formattedDate = date.toLocaleDateString('en-US', options);
    
    return formattedDate;
};
